import { Enums } from "@flightscope/baseball-stats";
import GenericColorMapping from "./GenericColorMapping";
import colors from "./helpers/colors";

/** @type {ColorMap} */
export default {
  [Enums.SwingDecision.Contact.key]: colors.green.vidaLoca,
  [Enums.SwingDecision.Whiff.key]: colors.red.thunderbird,
  [Enums.SwingDecision.Unclassified.key]: colors.grey.doveGray,
  ...GenericColorMapping
};
